import React, { Component } from "react"
import { connect } from 'react-redux'
import { submitSearchFacet } from '../Actions/FacetedSearch.action'
import InfoBox from "../Components/InfoBox"
import { translate } from "../Services/translation"

const optionsOrder = [
    "budget", "middle", "premium"
]

class PriceClassFilterContainer extends Component {
    constructor(props) {
        super(props)
    }

    handleActivateFilter(value, selectedOptions, options) {
        let selectedOptionsClone = [...selectedOptions]

        if (selectedOptionsClone.includes(value))
            selectedOptionsClone = selectedOptionsClone.filter(option => option !== value)
        else
            selectedOptionsClone.push(value)

        this.props.onSubmit([
            {
                label: "Prisklass",
                id: "PriceClass",
                selectedOptions: selectedOptionsClone,
                singleSelect: false,
                options: options
            }
        ])

    }

    render() {
        const { facetFilters } = this.props
        const priceClassFilter = facetFilters.find(x => x.id == "PriceClass")
        if (priceClassFilter == null)
            return <></>

        const currentSelectedOptions = priceClassFilter.selectedOptions

        return <>
            <div className="priceClassFilter">
                <div className="priceClassfilter__container">
                    <div className="priceClassFilter__text-container"><b>{priceClassFilter.label}</b>
                        <InfoBox right={false}>
                            <div className="priceClassFilter__info-container">
                                <p>
                                    <b>{translate("priceclassfilter.budget.title")}:</b> {translate("priceclassfilter.budget.text")}
                                </p>
                                <p>
                                    <b>{translate("priceclassfilter.middle.title")}:</b> {translate("priceclassfilter.middle.text")}
                                </p>
                                <p>
                                    <b>{translate("priceclassfilter.premium.title")}:</b> {translate("priceclassfilter.premium.text")}
                                </p>
                            </div>
                        </InfoBox>
                    </div>
                    <div className="priceClassFilter__button-container">
                        {priceClassFilter.options
                            .sort((a, b) => optionsOrder.indexOf(a.cssValue) - optionsOrder.indexOf(b.cssValue))
                            .map(option => (
                                <button
                                    key={option.cssValue}
                                    className={currentSelectedOptions.some(x => x == option.label) ? "active" : ""}
                                    onClick={() => this.handleActivateFilter(option.label, currentSelectedOptions, priceClassFilter.options)}
                                >
                                    {option.label}
                                </button>
                            ))}
                    </div>
                </div>
            </div>
        </>
    }
}
const mapStateToProps = ({
    facetedSearch: {
        facetFilters,
    }
}) => {
    return {
        facetFilters,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        onSubmit: (allFilters) => dispatch(submitSearchFacet(allFilters)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(PriceClassFilterContainer)